import { RunGroup } from "@custom-types/modelRun"
import { PublishedWithChanges } from "@mui/icons-material"
import { IconButton, Tooltip } from "@mui/material"
import { RunStatusDto } from "@store/services/runService"
import { getGraphVersionFromGraphKey } from "@utils/graph"

type RequestPublishingButtonProps = {
  runGroup: RunGroup
  onClick: (runGroup: RunGroup) => void
}

const RequestPublishingButton = (props: RequestPublishingButtonProps) => {
  const runs = Object.values(props.runGroup.runs)
  const allRunsDone = runs.every(({ status }) => status === RunStatusDto.DONE)

  const graphVersion = getGraphVersionFromGraphKey(props.runGroup.base_graph_key)
  const [, minor, patch] = graphVersion.split(".")
  const isGraphMinorVersion = minor !== "0" && patch === "0"
  // TODO- need to disallow if a major version > this version
  const errors: string[] = []
  if (!allRunsDone) errors.push("All runs in this run group must be successful")
  if (!isGraphMinorVersion) errors.push("Graph version must be minor (x.y.0)")

  const isDisabled = errors.length > 0

  return (
    <Tooltip
      title={isDisabled ? <DisabledTooltipContent errors={errors} /> : "Request publish externally"}
    >
      <span>
        <IconButton disabled={isDisabled} onClick={() => props.onClick(props.runGroup)}>
          <PublishedWithChanges />
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default RequestPublishingButton

const DisabledTooltipContent = ({ errors }: { errors: string[] }) => {
  return (
    <>
      You can not request publishing this graph.
      <ul style={{ padding: 5 }}>
        {errors.map((error, i) => (
          <li key={i}>{error}</li>
        ))}
      </ul>
    </>
  )
}
